import {observer} from "mobx-react";
import {Button, FormControl, Input, InputLabel} from "@material-ui/core";
import React, {useContext} from "react";
import {LocalizedInputProps} from "./TranslationStore";
import {useStores} from "../../../hooks";
import {useTranslation} from "react-i18next";
import { toLocalizedString } from "./../../libs";


const LocalizedInput = (props: LocalizedInputProps) => {
    const { generalStore } = useStores();
    const {t} = useTranslation(['menu', 'general']);
    const { translationStore } = useStores();
    const value =  props.value  || toLocalizedString("");
    const numberOfLines = props.numberOfLines || 1;

    return <FormControl fullWidth style={{marginTop: 10}}>
        <InputLabel>{props.label}</InputLabel>
        <Input
            value={value[generalStore.locale.id]}
            disabled
            endAdornment={<div onClick={() => {
                translationStore.showTranslationEditorForm();
                translationStore.setValue(value);
                translationStore.setLabel(props.label);
                translationStore.setNewValue(props.setNewValue);
                translationStore.setNumberOfLines(numberOfLines);
            }}>
                <Button
                    onClick={()=>{}}
                    color="primary">
                    {t("menu:edit")}
                </Button>
            </div>}
        />
    </FormControl>;
}

export default observer(LocalizedInput)
